// extracted by mini-css-extract-plugin
export default {"container":"_2DtGSp","contentWrapper":"_3ta9I-","content":"_2PYzlg"};